import { Spin, Tabs } from "antd";
import ListProgress from "./listProgress";
import { useEffect, useState } from "react";
import { useReport } from "../../../tools/api";

const InProgress = () => {
  const { sPSalesPerState, ePSalesPerState, dCSalesPerState, swSalesPerState, coSalesPerState } = useReport();
  const [reportList, setReportList] = useState([]);
  const [activeTab, setActiveTab] = useState("type01");

  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const initialServ = async () => {
      setLoading(true);
      if (activeTab === "type01") {
        let resResult = [];
        const responseSP = await sPSalesPerState();
        if (responseSP && !responseSP?.HasError) {
          resResult = responseSP.Result;
        }
        const responseSW = await swSalesPerState();
        if (responseSW && !responseSW?.HasError) {
          // setReportList((prev) => ({ ...prev, ...responseSW.Result }));
          resResult = [...resResult, ...responseSW.Result];
        }
        const responseCOS = await coSalesPerState();
        if (responseCOS && !responseCOS?.HasError) {
          resResult = [...resResult, ...responseCOS.Result];
        }
        setReportList(resResult);
      }
      if (activeTab === "type02") {
        const responseEP = await ePSalesPerState();
        if (responseEP && !responseEP?.HasError) {
          setReportList(responseEP.Result);
        }
      }
      if (activeTab === "type03") {
        const responseDC = await dCSalesPerState();
        if (responseDC && !responseDC?.HasError) {
          setReportList(responseDC.Result);
        }
      }
      setLoading(false);
    };
    initialServ();
  }, [activeTab]);
  const handleChange = (active) => {
    setActiveTab(active);
  };
  return (
    <div className="box-inprogress">
      <div className="holder-tab">
        <Tabs
          className="tab-report"
          onChange={handleChange}
          centered
          items={[
            {
              key: "type01",
              label: "سیم کارت",
              children: loading ? (
                <div style={{ height: "20rem", display: "flex", flexDirection: "column", alignContent: "center", justifyContent: "center" }}>
                  {" "}
                  <Spin />
                </div>
              ) : (
                <ListProgress reportList={reportList} />
              ),
            },

            {
              key: "type03",
              label: "بسته",
              children: loading ? (
                <div style={{ height: "20rem", display: "flex", flexDirection: "column", alignContent: "center", justifyContent: "center" }}>
                  {" "}
                  <Spin />
                </div>
              ) : (
                <ListProgress reportList={reportList} />
              ),
            },
            {
              key: "type02",
              label: "شارژ",
              children: loading ? (
                <div style={{ height: "20rem", display: "flex", flexDirection: "column", alignContent: "center", justifyContent: "center" }}>
                  {" "}
                  <Spin />
                </div>
              ) : (
                <ListProgress reportList={reportList} />
              ),
            },
          ]}
        />
      </div>
    </div>
  );
};

export default InProgress;
